import styled, { keyframes } from 'styled-components';

const stepEnter = keyframes`
  from {
    opacity: 0;
    transform: translateX(30px) scale(0.98);
  }
  to {
    opacity: 1;
    transform: translateX(0) scale(1);
  }
`;

const stepExit = keyframes`
  from {
    opacity: 1;
    transform: translateX(0) scale(1);
  }
  to {
    opacity: 0;
    transform: translateX(-30px) scale(0.98);
  }
`;

const StepWrapper = styled.div`
  width: 100%;
  animation: ${({ $back }) => ($back ? stepExit : stepEnter)} 0.28s
    cubic-bezier(0.22, 1, 0.36, 1) forwards;
`;

const StepWrapperComponent = ({ children, $back = false, ...props }) => {
  return (
    <StepWrapper $back={$back} {...props}>
      {children}
    </StepWrapper>
  );
};

export default StepWrapperComponent;
